__turbopack_context__.v({
  "foot": "htsJpG_foot",
  "item": "htsJpG_item",
  "list": "htsJpG_list",
  "mail": "htsJpG_mail",
  "menu": "htsJpG_menu",
  "rise": "htsJpG_rise",
  "search": "htsJpG_search",
  "sign": "htsJpG_sign",
  "veil": "htsJpG_veil",
  "whatsapp": "htsJpG_whatsapp",
});
